import { Data } from './data';
import { Produit } from './produit';

export class AvisProduit extends Data {

    pseudo: string;
    contact: string;
    avis: string;
    evaluation: number;
    produit: Produit

    constructor() {

        super();
        // this.montant = 0;
    }

    /* get text(): string{

        return this.designation;
    }

    get value(): number{

        return this.id;
    } */



}
